export interface IRelease {
    id?: number;
    programName?: string;
    programShortName?: string;
    release?: string;
    releaseWithZero?: string;
    musicOffline?: boolean;
    videoOffline?: boolean;
    guideOffline?: boolean;
    musicDirectory?: string;
    videoDirectory?: string;
    guideDirectory?: string;
    imageDirectory?: string;
    imagePath?: string;
    visible?: boolean;
    guideNumPages?: number;
    links?: any[];
    contentSource?: 'GOOGLE' | 'SERVER'; // 'GOOGLE' for old releases on Google Drive, 'SERVER' for new releases on server
}

export class Release implements IRelease {
    id = -1;
    programName = '';
    programShortName = '';
    release = '';
    releaseWithZero = '';
    musicOffline = false;
    videoOffline = false;
    guideOffline = false;
    musicDirectory = '';
    videoDirectory = '';
    guideDirectory = '';
    imageDirectory = '';
    imagePath = '';
    visible = false;
    guideNumPages = 0;
    links = new Array<any>();
    contentSource: 'GOOGLE' | 'SERVER' = 'GOOGLE'; // Default to GOOGLE for backward compatibility

    constructor() { }

    clearFields() {
        this.id = -1;
        this.programName = '';
        this.programShortName = '';
        this.release = '';
        this.releaseWithZero = '';
        this.musicOffline = false;
        this.videoOffline = false;
        this.guideOffline = false;
        this.musicDirectory = '';
        this.videoDirectory = '';
        this.guideDirectory = '';
        this.imageDirectory = '';
        this.imagePath = '';
        this.guideNumPages = 0;
        this.links = new Array<any>();
        this.contentSource = 'GOOGLE';
    }
}
